import "./banner/Banner.css";
import Home_Banner from "../home_banner/Home_Banner";
import City_Scroller from "./city_container/City_Container";
import TrendingTours from "../trending_tours/Trending_Tours";
import Exclusive_Gateway_Experiences from "./exclusive_gateway_experiences/Exclusive_Gateway_Experiences";
import Trusted_By_Travelers from "./trusted_by_travellers/Trusted_By_Travellers";
import Travel_Explore_Banner from "./travel_explore_banner/Travel_Explore_Banner";
import What_Our_Travelers_Say from "./what_our_travelers_say/What_Our_Travelers_Say";
import TravelGallery from "./travel-gallery/Travel_Gallery";
import TravelConfidence from "./travel-with-confidence/Travel_With_Confidence";
import Video from "./video/Video";

import { useContext, useEffect, useState } from "react";
import { Context } from "../../utils/context";
import { useParams } from "react-router-dom";

function Home() {
  const { getData } = useContext(Context);
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [trendingData, setTrendingData] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [allPackagesbyId, setAllPackagesbyId] = useState([]);

  // ✅ APIs
  const getDataAll = async () => {
    const response = await getData("/master/holiday/");
    setData(response?.data || []);
  };

  const getDataLocations = async () => {
    const response = await getData("/master/packagetype/");
    setLocations(response?.data || []);
  };

  const getTrendingDataAll = async () => {
    const response = await getData("/master/trending/");
    setTrendingData(response?.data || []);
  };

  const getAllPackages = async () => {
    const response = await getData("/master/package/");
    setAllPackages(response?.data || []);
  };

  useEffect(() => {
    getDataAll();
    getDataLocations();
    getTrendingDataAll();
    getAllPackages();
  }, []);

  // ✅ CONTINENT MAPPING (IMPORTANT 🔥)
  const continentMap = [
    { id: 1, title: "Europe Tours" },
    { id: 2, title: "Asia Tours" },
    { id: 3, title: "North America" },
    { id: 4, title: "South America" },
    { id: 5, title: "Africa" },
    { id: 6, title: "Australia" },
    { id: 7, title: "Antarctica" },
  ];

  return (
    <>
      <Home_Banner />

      <City_Scroller data={data} />

      {/* Trending */}
      {trendingData.length > 0 && (
        <TrendingTours titleText={"Trending Tours"} data={trendingData} />
      )}

      <Exclusive_Gateway_Experiences locations={locations} />

      <Video />
      <Trusted_By_Travelers />

      {/* ✅ Dynamic Continent Sections */}
      {continentMap.map((continent) => {
        const filteredData = allPackages.filter(
          (item) => item.package_type === continent.id,
        );

        if (filteredData.length === 0) return null;

        return (
          <TrendingTours
            key={continent.id}
            titleText={continent.title}
            data={filteredData}
          />
        );
      })}

      <TravelConfidence />
      <Travel_Explore_Banner />
      <What_Our_Travelers_Say />
      <TravelGallery />
    </>
  );
}

export default Home;
